import React, {
    Component
} from 'react'
import App from './components/App'
import AppMobile from './components/mobile/AppMobile'

export class Application extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({
            width: window.innerWidth
        });
    };

    render() {
        const {
            width
        } = this.state;

        if (width > 800) {
            return ( <
                App / >
            )
        } else {
            return ( <
                AppMobile / >
            );
        }
    }
}


export default Application